import { createFileRoute } from '@tanstack/react-router'
import { scorecardsRepository } from '@/data/adapters/api/scorecards.api'

export interface ScorecardsPageSearch {
  /** Shows the weekly target review panel. Demo-only until the metric catalog is agreed. */
  review?: boolean
}

export const Route = createFileRoute('/$orgSlug/$clientSlug/scorecards')({
  validateSearch: (search: Record<string, unknown>): ScorecardsPageSearch => ({
    review: search.review === true || search.review === '1' || search.review === 'true' ? true : undefined,
  }),
  loader: ({ context: { queryClient, client } }) =>
    Promise.all([
      queryClient.ensureQueryData({
        queryKey: ['scorecards', 'weekly', client.id, 'monday'],
        queryFn: () => scorecardsRepository.getWeeklyScorecard(client.id, 'monday'),
      }),
      queryClient.ensureQueryData({
        queryKey: ['scorecards', 'monthly', client.id],
        queryFn: () => scorecardsRepository.getMonthlyScorecard(client.id),
      }),
    ]),
})
